export default function ImplantTypes() {
  const types = [
    {
      icon: 'ri-tooth-line',
      title: 'Single Tooth Implant',
      description: 'Replace one missing tooth with a natural-looking dental implant in Chelmsford. Perfect solution for individual tooth loss with long-lasting results.',
      image: 'https://static.readdy.ai/image/0a3008c36638439fa5d134c9c6a19be7/f5ec22f92b0e4c6d936159be3ccdbefd.png'
    },
    {
      icon: 'ri-hospital-line',
      title: 'All on 4 Dental Implants',
      description: 'Revolutionary All on 4 technique replaces a full arch of teeth using just four strategically placed dental implants in Essex. Cost-effective and efficient.',
      image: 'https://public.readdy.ai/ai/img_res/b39652823f5d2208ef367f33be60cb22.jpg'
    },
    {
      icon: 'ri-star-smile-line',
      title: 'All on X Implants',
      description: 'Advanced All on X dental implant system for complete smile restoration in Chelmsford. Customized number of implants for optimal stability and comfort.',
      image: 'https://readdy.ai/api/search-image?query=all%20on%20x%20dental%20implants%20diagram%20showing%20multiple%20implant%20posts%20supporting%20full%20arch%20restoration%20with%20titanium%20screws%20in%20jawbone%20cross%20section%20view%20clean%20white%20medical%20illustration%20style&width=400&height=300&seq=allonximg001&orientation=landscape'
    },
    {
      icon: 'ri-time-line',
      title: 'Smile in a Day',
      description: 'Transform your smile in just one day with our Smile in a Day treatment. Walk in with missing teeth, leave with a beautiful, functional smile using immediate load dental implants.',
      image: 'https://readdy.ai/api/search-image?query=immediate%20load%20dental%20implants%20showing%20same%20day%20tooth%20replacement%20with%20temporary%20crown%20on%20implant%20post%20in%20jawbone%20cross%20section%20view%20clean%20white%20medical%20illustration%20style&width=400&height=300&seq=smileday001&orientation=landscape'
    },
    {
      icon: 'ri-user-smile-line',
      title: 'Implant-Retained Dentures',
      description: 'Secure dentures in Chelmsford with dental implants for superior stability. No slipping or discomfort - enjoy confident eating and speaking with implant-retained dentures.',
      image: 'https://readdy.ai/api/search-image?query=implant%20retained%20dentures%20showing%20denture%20attachment%20to%20implant%20posts%20with%20ball%20and%20socket%20connection%20system%20in%20jawbone%20cross%20section%20view%20clean%20white%20medical%20illustration%20style&width=400&height=300&seq=denture002&orientation=landscape'
    },
    {
      icon: 'ri-building-line',
      title: 'Full Arch Restoration',
      description: 'Complete upper or lower arch replacement with dental implants in Essex. Restore full function and aesthetics with our comprehensive full arch dental implant solutions.',
      image: 'https://readdy.ai/api/search-image?query=full%20arch%20dental%20restoration%20showing%20complete%20upper%20and%20lower%20teeth%20replacement%20with%20multiple%20implant%20posts%20in%20jawbone%20cross%20section%20view%20clean%20white%20medical%20illustration%20style&width=400&height=300&seq=fullarch002&orientation=landscape'
    },
  ];

  return (
    <section className="py-20 bg-white" id="implant-types">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#444c42] mb-4">
            <strong>Dental Implant Options in Chelmsford Essex</strong>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our <strong>dental implant specialist</strong> offers comprehensive tooth replacement solutions including <strong>All on 4</strong>, <strong>All on X</strong>, and <strong>Smile in a Day</strong> treatments for patients across Chelmsford and Essex
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {types.map((type, index) => (
            <div
              key={index}
              className="bg-gray-50 rounded-xl p-8 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 border border-gray-100"
            >
              <div className="w-16 h-16 bg-[#D0A24F] rounded-full flex items-center justify-center mb-6">
                <i className={`${type.icon} text-3xl text-white`}></i>
              </div>
              
              {/* Image */}
              <div className="w-full h-48 mb-6 rounded-lg overflow-hidden bg-white">
                <img
                  src={type.image}
                  alt={type.title}
                  className="w-full h-full object-contain object-center"
                />
              </div>

              <h3 className="text-2xl font-bold text-[#444c42] mb-4">
                <strong>{type.title}</strong>
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {type.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button
            onClick={() => {
              const element = document.getElementById('booking');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-[#D0A24F] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#F5d383] transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Book Your Free Consultation
          </button>
        </div>
      </div>
    </section>
  );
}
